// extracted by mini-css-extract-plugin
export default {"dialog-popup":"DialogPopup_dialog-popup__h5QxR","buttons":"DialogPopup_buttons__nay39"};